import { getApiUrl } from '@/js/utils/getApiUrl';
import { getBitrixSessid } from '@/js/utils/getBitrixSessid';
import type { ReportFormSignPayload } from './sign-types';

export class ReportFormSignApi {
  constructor(
    private readonly reportId?: string,
    private readonly signEndpoint?: string,
    private readonly zipEndpoint?: string,
  ) {}

  async signReport(payload: ReportFormSignPayload): Promise<Response> {
    const reportId = payload.id || this.reportId;
    if (!reportId) {
      throw new Error('ID отчёта не указан');
    }

    const sessid = getBitrixSessid();
    if (!sessid) {
      throw new Error('Не удалось получить CSRF-токен. Обновите страницу и попробуйте снова.');
    }

    const body = new FormData();
    body.append('id', reportId);
    body.append('content', payload.content);
    body.append('signature', payload.signature);
    body.append('sessid', sessid);

    const endpoint =
      this.signEndpoint ?? getApiUrl(`/api/personal/report/${reportId}/sign/`);

    return fetch(endpoint, {
      method: 'POST',
      body,
      credentials: 'same-origin',
      headers: {
        'X-Bitrix-Csrf-Token': sessid,
      },
    });
  }

  getSignedArchiveUrl(id: string): string {
    const url = new URL(
      this.zipEndpoint ?? getApiUrl(`/api/personal/report/${id}/archive/`),
      window.location.origin,
    );
    url.searchParams.set('allFile', '1');
    return url.toString();
  }
}
